<template>
    <app-layout title="Profile">
        <template #header>
            <h2 class="text-3xl font-bold tracking-tight text-white">
                {{ __('Profile') }}
            </h2>
        </template>

      <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
        <aside class="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
          <nav class="space-y-1 p-4 bg-white rounded-lg shadow">
            <span v-for="item in navigation" :key="item.view" @click="view = item.view"
                  :class="[item.view === view ? 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-600/20' : 'text-gray-900 hover:text-gray-900 hover:bg-gray-100', 'group rounded-md px-3 py-2 flex items-center text-sm font-medium cursor-pointer']"
                  :aria-current="item.view === view ? 'page' : undefined">
                <component :is="item.icon"
                           :class="[item.view === view ? 'text-green-700 group-hover:text-green-700' : 'text-gray-400 group-hover:text-gray-500', 'flex-shrink-0 -ml-1 mr-3 h-6 w-6']"
                           aria-hidden="true"/>
                <span class="truncate">
                    {{ item.name }}
                </span>
            </span>
          </nav>
        </aside>

        <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">

          <update-profile-information-form :user="$page.props.user" :countries="countries" v-if="view === 'account'"/>
          <update-password-form v-if="view === 'password'"/>
          <two-factor-authentication-form v-if="view === 'two-factor'"/>
          <logout-other-browser-sessions-form :sessions="sessions" v-if="view === 'sessions'"/>

        </div>
      </div>
    </app-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import DeleteUserForm from '@/Pages/Profile/Partials/DeleteUserForm.vue'
    import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
    import LogoutOtherBrowserSessionsForm from '@/Pages/Profile/Partials/LogoutOtherBrowserSessionsForm.vue'
    import TwoFactorAuthenticationForm from '@/Pages/Profile/Partials/TwoFactorAuthenticationForm.vue'
    import UpdatePasswordForm from '@/Pages/Profile/Partials/UpdatePasswordForm.vue'
    import UpdateProfileInformationForm from '@/Pages/Profile/Partials/UpdateProfileInformationForm.vue'
    import { KeyIcon, UserCircleIcon, ShieldCheckIcon, UsersIcon } from '@heroicons/vue/outline'

    export default defineComponent({
        props: ['sessions', 'countries'],
        components: {
            AppLayout,
            DeleteUserForm,
            JetSectionBorder,
            LogoutOtherBrowserSessionsForm,
            TwoFactorAuthenticationForm,
            UpdatePasswordForm,
            UpdateProfileInformationForm,
        },
        data() {
            return {
                view: 'account',
                navigation: [
                    { name: this.__('Account'), view: 'account', icon: UserCircleIcon },
                    { name: this.__('Password'), view: 'password', icon: KeyIcon },
                    { name: this.__('Two Factor Authentication'), view: 'two-factor', icon: ShieldCheckIcon },
                    { name: this.__('Sessions'), view: 'sessions', icon: UsersIcon },
                ]
            }
        }
    })
</script>
